import axios        from 'axios'
import store        from '@/store'
import bus          from '@/utils/bus'
import sleep        from '@/utils/sleep'
import { CONFIG }   from '@/utils/constants'
import { getToken }  from '@/services/auth'


const save = async (data, i = 0) => {
    try {
        if (i > 5) return
        
        if (!store.getters[CONFIG.GET]) {
            await sleep(2000)
            return save(data, ++i)
        }
        
        const options = {
            headers: {
                'Authorization': getToken(),
                'Tenant': store.getters[CONFIG.GET].tenantId
            }
        }
        const body = { table: 'logTrace', data }

        return axios.post(`${process.env.CRUD_API_SAVE}/save`, body, options)

    } catch (err) {
        console.log(err)
        if (err && err.status === 401) {
            bus.$emit('unauthorized')
            return
        }

        return save(data, ++i)
    }
}

export default save


// WEBPACK FOOTER //
// ./src/services/logTrace/save.js